import { CompanyAuthenticationTabController } from '../controller/CompanyAuthenticationTabController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { CompanyActionContext } from '../../types/CompanyActionContext';
import { getContext } from '../../../../componentHelpers/getters';
import { CompanyEditingRight } from '../../types/CompanyEditingRight';

export class CompanyAuthenticationTabWebComponent extends BaseWebComponentElement {
  public controller!: CompanyAuthenticationTabController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: CompanyAuthenticationTabController,
    });
  }

  public get hasUnsavedChanges(): boolean {
    return this.controller.view.formGroup.hasUnsavedChanges;
  }

  get companyId(): string {
    const data = this.getAttribute('data-company-id');
    return data ?? '';
  }

  set companyId(companyId: string) {
    this.setAttribute('data-company-id', companyId);
  }

  public set editingRight(editingRight: CompanyEditingRight) {
    this.setAttribute('editing-right', editingRight);
  }

  public get editingRight(): CompanyEditingRight {
    const editingRight = this.getAttribute('editing-right');
    return editingRight ? (editingRight as CompanyEditingRight) : CompanyEditingRight.Full;
  }

  public discardFormChanges(): void {
    return this.controller.view.discardFormChanges();
  }

  public get formContext(): CompanyActionContext {
    return getContext.call(this);
  }

  public set formContext(context: CompanyActionContext) {
    this.setAttribute('context', context);
  }
}
